/* Desktop dropdowns and mobile in-place accordions use the same category links. */
(() => {
  const menus = () => [...document.querySelectorAll('.nhc-desktop,.nhc-mobile')];
  const closeAll = except => menus().forEach(menu => { if(menu!==except)menu.open=false; });
  function syncMobile() {
    const drawer=document.querySelector('#NorgiraMobileMenu');
    if(!drawer)return;
    drawer.querySelectorAll('.norgira-mobile-menu__primary > *').forEach(item=>{item.inert=false;});
    const utility=drawer.querySelector('.norgira-mobile-menu__utility');
    if(utility)utility.inert=false;
  }
  function setup() {
    menus().forEach(menu=>{
      if(menu.dataset.nhcReady)return;
      menu.dataset.nhcReady='true';
      const summary=menu.querySelector('summary');
      menu.addEventListener('toggle',()=>{
        summary.setAttribute('aria-expanded',String(menu.open));
        if(menu.open)closeAll(menu);
        syncMobile();
      });
      menu.addEventListener('keydown',event=>{
        if(event.key==='Escape'){event.preventDefault();event.stopPropagation();menu.open=false;syncMobile();summary.focus();}
        if(event.key==='ArrowDown'&&event.target===summary){event.preventDefault();closeAll(menu);menu.open=true;menu.querySelector('.nhc-panel a')?.focus();}
      });
      if(menu.classList.contains('nhc-desktop'))menu.addEventListener('focusout',()=>setTimeout(()=>{if(!menu.contains(document.activeElement))menu.open=false;},0));
    });
    if(document.documentElement.dataset.nhcGlobalReady)return;
    document.documentElement.dataset.nhcGlobalReady='true';
    document.addEventListener('pointerdown',event=>{if(!event.target.closest('.nhc-desktop'))document.querySelectorAll('.nhc-desktop').forEach(menu=>{menu.open=false;});});
    document.addEventListener('click',event=>{if(event.target.closest('[data-norgira-search-open],[data-norgira-menu-close],.nhc-panel a')){closeAll();syncMobile();}});
    window.matchMedia('(min-width:1200px)').addEventListener('change',()=>{closeAll();syncMobile();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
  document.addEventListener('shopify:section:load',setup);
})();
